export default __webpack_public_path__ + "static/media/saad.791ca224.png";